import type { FormFields } from './form-fields';
import type { FormSection } from './form-section';

export interface Form {
	readonly fields: FormFields;
	readonly sections: FormSection[];
	readonly id: string;
}

/**
 * Configuration to customise which fields are visible on a rendered Form.
 *
 * It is split into `fieldSet` where some pre-defined sets are defined, while `sectionIds` and `fieldIds` allow
 * for fine-grained control over individual sections/fields. Everything in FormFieldVisibility is additive, e.g.
 * `fieldIds` will be applied on top of the selected `fieldSet`.
 */
export type FormFieldVisibility = {
	fieldSet: VisibilityFieldSet[];
};

// oxlint-disable-next-line eslint/no-redeclare
export const VisibilityFieldSet = {
	ALL_FIELDS: 'allFields',
	VISIBLE_SECTION_FIELDS: 'visibleSectionFields',
} as const;

export type VisibilityFieldSet = (typeof VisibilityFieldSet)[keyof typeof VisibilityFieldSet];
